import React from 'react';

import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  makeStyles,
  Theme,
} from '@material-ui/core/';
import { DialogProps as MuiDialogProps } from '@material-ui/core/Dialog';
import clsx from 'clsx';

import { IconButton, Typography } from '../../atoms';
import { ArrowLeft as ArrowLeftIcon, X as XIcon } from '../../icons';

export interface DialogProps extends MuiDialogProps {
  actions?: JSX.Element[] | JSX.Element;
  children: React.ReactNode;
  endIcon?: JSX.Element;
  onTitleClick?: React.MouseEventHandler<HTMLButtonElement>;
  startIcon?: JSX.Element;
  title?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  defaultTitle: {
    [theme.breakpoints.up('sm')]: {
      '& .iconLeft': {
        display: 'none',
      },

      '& .iconRight': {
        display: 'block',
      },
    },
  },
}));

export const Dialog = (props: DialogProps): JSX.Element => {
  const {
    actions = null,
    children,
    endIcon,
    onTitleClick = null,
    startIcon,
    title = '',
    ...rest
  } = props;

  const classes = useStyles();
  const dialogTitleStyles = clsx(onTitleClick && classes.defaultTitle);

  return (
    <MuiDialog aria-label={title} {...rest}>
      <MuiDialogTitle className={dialogTitleStyles} disableTypography>
        {!onTitleClick ? (
          <>
            {startIcon}
            <Typography variant="h3">{title}</Typography>
            {endIcon}
          </>
        ) : (
          <>
            <IconButton
              className="iconLeft"
              color="secondary"
              disableRipple
              onClick={onTitleClick}
            >
              <ArrowLeftIcon />
            </IconButton>

            <Typography variant="h3">{title}</Typography>

            <IconButton
              className="iconRight"
              color="secondary"
              disableRipple
              onClick={onTitleClick}
            >
              <XIcon />
            </IconButton>
          </>
        )}
      </MuiDialogTitle>

      <MuiDialogContent>{children}</MuiDialogContent>

      {actions && <MuiDialogActions>{actions}</MuiDialogActions>}
    </MuiDialog>
  );
};
